module.exports = __webpack_public_path__ + "static/media/cal.7fa591db.jpg";